// extracted by mini-css-extract-plugin
export default {"container":"RecentlyAdded_container__djw8Y","content":"RecentlyAdded_content__KXk4Q","emptyShelf":"RecentlyAdded_emptyShelf__T1s-T","loader":"RecentlyAdded_loader__kjEgK"};